module.exports = __webpack_public_path__ + "media/images/svg/clients/11-0f852bbdda7f0a6ee068a80ec3b879ba.svg";